export default {
  about: 'Относно',
  addOns: 'Допълнения',
  agenda: 'Програма',
  all: 'Всички',
  at: 'в',
  browse: 'Преглед',
  buyTickets: 'Купи билети',
  countSelected: 'Избрани {{count}}',
  included: 'Включено',
  joinWaitlist: 'Запиши се в листата на чакащите',
  joining: 'Записване',
  menu: 'Меню',
  noDatesAvailable: 'Няма налични дати',
  salesEnded: 'Продажбите приключиха',
  schedule: 'График',
  seeMoreDates: 'Вижте повече дати',
  soldOut: 'Разпродадено',
  tickets: 'Билети',
  viewMore: 'Вижте повече',
  viewLess: 'Вижте по-малко',
  location: 'Местоположение',
  time: 'Час',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Няма налични часове на тази дата за този брой гости',
  availableTimes: 'Налични часове',
  waitlist: 'Листа на чакащите',
  continue: 'Продължи',
  ticketsAreNoLongerAvailable: 'Билетите вече не са налични.',
  checkOutOutOtherExperiences: 'Разгледайте другите ни преживявания!',
  viewExperiences: 'Преглед на преживявания',
  from: 'от',
  cancellationPolicy: 'Политика за анулиране',
  rsvp: 'RSVP',
  nights: 'нощувки',
  request: 'Заявка',
  arrival: 'Пристигане',
  departure: 'Заминаване',
};
